import { userService } from "../_services";

function handleResponse(response, customErrorMsg) {
  if (response?.status === 401) {
    userService.logout();
  }
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error =
        data?.message ||
        data?.description ||
        response.statusText ||
        customErrorMsg;
      return Promise.reject(error);
    }

    return data;
  });
}

function handleNoContentResponse(response, customErrorMsg) {
  if (response.status === 204) {
    const data = { response: response.status };
    return data;
  }
  if (response.status === 401) {
    userService.logout();
  }
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      const error =
        data?.message ||
        data?.description ||
        response.statusText ||
        customErrorMsg;
      return Promise.reject(error);
    }

    return data;
  });
}

function handleWithClearErrorResponse(response) {
  if (response.status === 204) {
    const data = { response: response.status };
    return data;
  }
  if (response.status === 401) {
    userService.logout();
  }
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      return Promise.reject(data);
    }

    return data;
  });
}

function errorOnActivation(response) {
  //customErrorMsg
  if (response.status === 204) {
    const data = { response: response.status };
    return data;
  }
  if (response.status === 401) {
    userService.logout();
  }
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      return Promise.reject(data);
    }

    return data;
  });
}

function forDownload(response) {
  if (response.status === 204) {
    const data = { response: response.status };
    return data;
  }
  if (response.status === 401) {
    userService.logout();
  }
  if (response.status === 200) {
    return response.blob().then((blob) => {
      const url = URL.createObjectURL(blob);
      return { download: "Done", url };
    });
  }
  if (!response.ok) {
    const data = response.text();
    return Promise.reject(data);
  }
}

export {
  handleResponse,
  handleNoContentResponse,
  errorOnActivation,
  forDownload,
  handleWithClearErrorResponse,
};
